import 'react-toastify/dist/ReactToastify.min.css';

import React from 'react';
import { toast } from 'react-toastify';

import Alert from '../components/Alert';
import { scrollWindowToTop } from './scroll';

const toastify = {
  error: (
    msg,
    config = {
      closeButton: false,
      position: 'top-center',
      hideProgressBar: true
    }
  ) => {
    toast.dismiss();
    scrollWindowToTop();
    return toast(<Alert type="error">{msg}</Alert>, config);
  },
  warning: (
    msg,
    config = {
      closeButton: false,
      position: 'top-center',
      hideProgressBar: true
    }
  ) => {
    toast.dismiss();
    scrollWindowToTop();
    return toast(<Alert type="warning">{msg}</Alert>, config);
  },
  success: (
    msg,
    config = {
      closeButton: false,
      position: 'top-center',
      hideProgressBar: true
    }
  ) => {
    toast.dismiss();
    scrollWindowToTop();
    return toast(<Alert type="success">{msg}</Alert>, config);
  },
  info: (
    msg,
    config = {
      closeButton: false,
      position: 'top-center',
      hideProgressBar: true
    }
  ) => {
    toast.dismiss();
    scrollWindowToTop();
    return toast(<Alert type="info">{msg}</Alert>, config);
  },
  remove: id => {
    toast.dismiss();
    scrollWindowToTop();
    return toast.dismiss(id);
  },
  dismissAll: () => {
    scrollWindowToTop();
    return toast.dismiss();
  }
};

export default toastify;
